import script from "./ElegantErrorDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ElegantErrorDialog.vue?vue&type=script&setup=true&lang=js"

import "./ElegantErrorDialog.vue?vue&type=style&index=0&id=cf18de6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf18de6c"]])

export default __exports__